import { BottomDockObserver } from '@Shared/Common';

var adhesiveAdObserver = function adhesiveAdObserver(config) {
  var external = {};
  var internal = {
    isRdp: false,
    isPdp: false,
    rdpSelector: '.recipeDetail',
    pdpSelector: '.productDetail',
    spacingSelector: '.adhesiveAdSpacing',
    adhesiveAdSelector: '.adhesiveAd',
    adhesiveHeaderAdFixedClass: 'adhesiveHeaderAdFixed'
  };

  if (config && config.testMode === true) {
    external.internal = internal;
  }

  internal.logMessage = function (message, forceLog) {
    if (external.debugMode === true || forceLog) {
      console.log("[AdhesiveAd] " + message);
    }
  };

  internal.setupHeaderAdSpacing = function () {
    var spacing = document.querySelector(internal.spacingSelector);

    if (spacing) {
      spacing.classList.add('visible');
      if (internal.isRdp || internal.isPdp) spacing.classList.add('visibleDesktop');
      document.body.classList.add(internal.adhesiveHeaderAdFixedClass);
    }

    var ad = document.querySelector(internal.adhesiveAdSelector);

    if (ad) {
      var closeButtons = ad.getElementsByClassName('closeAdButton');

      for (var i = 0; i < closeButtons.length; i++) {
        closeButtons[i].onclick = function () {
          if (spacing) spacing.classList.remove('visible');
          document.body.classList.remove(internal.adhesiveHeaderAdFixedClass);
        };
      }
    }
  };

  internal.addObserver = function () {
    internal.setupHeaderAdSpacing();
  };

  internal.initialize = function () {
    internal.isRdp = !!document.querySelector(internal.rdpSelector);
    internal.isPdp = !!document.querySelector(internal.pdpSelector);
    var adhesiveAd = document.querySelector(internal.adhesiveAdSelector);

    if (adhesiveAd && adhesiveAd.children.length > 0) {
      if (internal.isRdp || internal.isPdp) adhesiveAd.classList.add('bottomAdhesiveAdMobile');
      internal.addObserver();
    }
  }; //init during object constructrion


  internal.initialize(config);
  return external;
};

export default adhesiveAdObserver;